/**
 * mobile 申請成功提示頁面
 */
/* eslint-disable react/jsx-max-depth */
import React from 'react';
import { useIntl, useSelector } from 'umi';
import type { StepModelsState } from 'umi';
import { Divider } from 'antd';
import { MoBaseContainer as BaseContainer } from '@gov-mo/components';
import HandleButton from '@/components/HandleButton';
import submitSuccessImg from '@/assets/submit-success.png';
import { Page } from '@gov-mo/mpaas-js-bridge';
import * as queryString from 'query-string';
import styles from './MobileComplete.less';

export default function MobileComplete() {
  const intl = useIntl();
  const { workNo } = useSelector(({ stepModels }: { stepModels: StepModelsState }) => stepModels);
  const query = queryString.parse(window.location.search);
  const { isPay = false } = query || {};

  return (
    <BaseContainer
      type="custom"
      onLeftClick={() => {
        Page.close();
      }}
    >
      <div className={styles.root}>
        <div className={styles.container}>
          <img src={submitSuccessImg} alt="submit-success" className={styles.successImg} />
          <div className={styles.content}>
            <div className={styles.successWarn}>
              {intl.formatMessage({ id: isPay ? '支付成功' : '成功提交申请' })}
            </div>
            <div className={styles.successInfoArea}>
              <div className={styles.infoItem}>
                <div className={styles.itemValue}>{intl.formatMessage({ id: 'Demo事项' })}</div>
              </div>
              <div className={styles.infoItem}>
                <div className={styles.itemKey}>{intl.formatMessage({ id: '申请编号' })}</div>
                <div className={styles.itemNumber}>{workNo}</div>
              </div>
            </div>
            <Divider className={styles.dashedDivider} />
            <div className={styles.successMsg}>
              {intl.formatMessage({
                id: '阁下亦可登入一户通查询本申请进度，审批完成后系统亦会显示通知。',
              })}
            </div>
          </div>
        </div>
        <HandleButton
          rightButton={{
            text: intl.formatMessage({ id: '完成' }),
            onClick: () => {
              Page.close();
            },
          }}
        />
      </div>
    </BaseContainer>
  );
}
